import React, { useEffect, useState } from "react";
import Print_DesignCaller from "./Print_DesignCaller";
import { useDispatch, useSelector } from "react-redux";
import { Pre_Loading, Show_Message } from "../General/Messagedialogbox";
import { API_POST, View_ScreenName } from "./Utility";
import { ShowHide_Popup } from "../features/Transactionstates";
function EmailPopup(props) {
  const dispatch = useDispatch();
  const _AuthParems = useSelector((state) => state.Common.Admin);
  // Transaction.js renders <EmailPopup /> with NO props, so the voucher / screen
  // come from the store (same source TransactionView uses)
  const _Common = useSelector((state) => state.Transstates?.Common);
  const _HT = useSelector((state) => state.Transstates?.Header);
  const iScrId = props.iScrId ?? props.ScrId ?? _Common?.iScrId;
  const iVouchId =
    props.iVouchId || _HT?.SelectedVouchId || _HT?.iVouchId || 0;

  // SMTP host / port / password are NOT kept in the browser any more.
  // The server reads them from the company settings (SendVoucherEmail).
  // strEmail is only shown to the user (read only "From").
  const [strEmail, setstrEmail] = useState("");
  const [strToEmail, setstrToEmail] = useState("");
  const [strSubject, setstrSubject] = useState("");
  const [strMessage, setstrMessage] = useState("");
  const [strScrName, setstrScrName] = useState("");
  const [objEntPdfContent, setobjEntPdfContent] = useState("");
  const [bSending, setbSending] = useState(false);

  useEffect(() => {
    Load_parytyinfo();
  }, []);

  // props.Close is never passed, so the close icon did nothing.
  // ShowHide_Popup closes every other popup, so opening this one closed the
  // View list. Closing goes back to the View list (IsTransView) so the user
  // can continue with the next voucher
  const Popup_Close = () => {
    if (props.Close) props.Close();
    else dispatch(ShowHide_Popup("IsTransView"));
  };

  const Load_parytyinfo = async () => {
    if (!iVouchId) {
      Show_Message(dispatch, "Please Select Voucher", "info");
      Popup_Close();
      return;
    }
    await Pre_Loading(dispatch, true);
    try {
      // Same path the Print / PDF buttons use (PrintDesing/Print_Data/...).
      // The old code called PrintDesing/PrintPreView/... which is a different
      // endpoint with a different parameter order
      const objEntPdf = await Print_DesignCaller(
        _AuthParems,
        iScrId,
        "Transaction",
        iVouchId,
        0,
        "PDF",
        dispatch,
        true
      );
      if (!objEntPdf || !objEntPdf.PartyInfo || !objEntPdf.PartyInfo[0]) {
        Show_Message(dispatch, "Unable to prepare the invoice PDF", "info");
        Popup_Close();
        return;
      }
      const name = props.ScrName || (await View_ScreenName(iScrId));
      setstrScrName(name || "Invoice");
      setobjEntPdfContent(objEntPdf);
      let company = (objEntPdf.CompanyInfo && objEntPdf.CompanyInfo[0]) || {};
      setstrToEmail(CleanEmail(objEntPdf.PartyInfo[0].email));
      setstrEmail(CleanEmail(company.compEMail));
      setstrSubject(
        `${name || "Invoice"} ${VoucherNo(objEntPdf)}${
          _AuthParems.Branchname ? " from " + _AuthParems.Branchname : ""
        }`.trim()
      );
    } catch (e) {
      Show_Message(dispatch, (e && e.message) || "Unable to prepare the invoice PDF", "error");
    } finally {
      await Pre_Loading(dispatch, false);
    }
  };

  // "E-mail : abc@x.com" (print prefix) -> "abc@x.com"
  const CleanEmail = (strValue) =>
    String(strValue || "")
      .replace(/^\s*e-?mail\s*:\s*/i, "")
      .trim();

  // PrintInvoice sets FileName = voucher no for every screen (VoucherName)
  const VoucherNo = (Info) => {
    const p = (Info && Info.PartyInfo && Info.PartyInfo[0]) || {};
    return Info && Info.FileName && Info.FileName !== "Invoice"
      ? Info.FileName
      : p.salInvNo || p.posInvNo || p.posRetNo || p.salRetNo || p.vouchNo || "";
  };
  // POS print data uses posInvDate / posRetDate, sales screens salInvDate ...
  const VoucherDate = (p) =>
    (p &&
      (p.salInvDate || p.posInvDate || p.salRetDate || p.posRetDate || p.vouchDate)) ||
    "";
  const PartyName = (p) =>
    (p && (p.custName || p.partyName || p.printName)) || "";

  const BuildMessage = (Info) => {
    const partyinfo = Info.PartyInfo[0];
    const Summary = (Info.Summary && Info.Summary[0]) || {};
    const strCompanyName = _AuthParems.Branchname;
    const strNo = VoucherNo(Info);
    // Info.mobile does not exist in the print data, it printed "undefined"
    const strContact = Info.mobile ? ` at ${Info.mobile}` : "";
    const strNote =
      strMessage.trim() !== "" ? `\n${strMessage.trim()}\n` : "";
    const strDate = VoucherDate(partyinfo);
    const strDateLine = strDate
      ? `Date: ${strDate}\n`
      : "";

    if (strScrName === "Sales Invoice") {
      return `
      Dear ${PartyName(partyinfo) || "Customer"},
      Thank You for Your Recent Purchase Invoice-#${strNo}
      
      We hope this message finds you well. We want to express our sincere gratitude for choosing ${strCompanyName} for your recent purchase. We appreciate your trust in our Products.
      
      Your order details are as follows:
      
      Invoice Number: ${strNo}
      Date of Purchase: ${strDate}
      Total Amount: ₹${stringtodecimal(Summary.netAmt)}
      ${strNote}
      We understand that you have a choice when it comes to your Product needs, and we are thrilled to have had the opportunity to serve you. Our team is committed to providing top-notch quality and excellent customer service, and we hope your recent experience reflects that commitment.
      
      If you have any questions about your purchase or if there's anything else we can assist you with, please don't hesitate to reach out to our customer support team${strContact}.
      
      Once again, thank you for choosing ${strCompanyName}. We truly value your business and look forward to serving you again in the future.
      
      Best Regards,
      ${strCompanyName}`;
    }
    // Quotation / Order / Challan / Purchase / Return ... screens
    return `
      Dear ${PartyName(partyinfo) || "Sir / Madam"},

      Please find attached ${strScrName} #${strNo} from ${strCompanyName}.

      ${strDateLine}Total Amount: ₹${stringtodecimal(Summary.netAmt)}
      ${strNote}
      If you have any questions, please don't hesitate to contact us${strContact}.

      Best Regards,
      ${strCompanyName}`;
  };

  const SentEmail = async (Info) => {
    if (bSending) return; // double click sent 2 mails
    setbSending(true);
    await Pre_Loading(dispatch, true);
    let bSent = false;
    try {
      // PrintInvoice FileName has no ".pdf", the attachment arrived without
      // an extension
      // voucher no like "INV/24/001" must not become a folder path
      const strFileName = (
        /\.pdf$/i.test(Info.FileName || "")
          ? Info.FileName
          : (Info.FileName || "Invoice") + ".pdf"
      ).replace(/[\\/:*?"<>|]/g, "_");
      const formdata = new FormData();
      // the server finds the SMTP settings from these 4 values
      formdata.append("iScrId", iScrId);
      formdata.append("iVouchId", iVouchId);
      formdata.append("iBranchId", Number(_AuthParems.Branch));
      formdata.append("strDBName", _AuthParems.DB);
      formdata.append("strToEmail", ToEmailList().join(","));
      // the typed text used to go to the subject, and the subject was empty
      formdata.append("strSubject", strSubject.trim());
      // template indent spaces are removed from every line of the mail
      formdata.append(
        "strBody",
        BuildMessage(Info).replace(/^[ \t]+/gm, "").trim()
      );
      const fileAttachment = await UrlToFile(Info.PdfURL, strFileName);
      if (!fileAttachment || !fileAttachment.size)
        throw new Error("The invoice PDF is empty. Please try again.");
      formdata.append("Attachment", fileAttachment);
      formdata.append("FileName", strFileName);
      const res = await API_POST(
        `Transaction/SendVoucherEmail`,
        formdata,
        dispatch
      );
      // the server may answer with an object, true, or plain text
      if (res) {
        Show_Message(
          dispatch,
          (typeof res === "object" && res.strMessage) ||
            (typeof res === "string" && res.trim()) ||
            "E-mail sent successfully",
          "success"
        );
        bSent = true;
      }
    } catch (e) {
      Show_Message(
        dispatch,
        (e && e.message) || "E-mail could not be sent. Please try again.",
        "error"
      );
    } finally {
      await Pre_Loading(dispatch, false);
      setbSending(false);
    }
    if (bSent) Popup_Close();
  };
  const stringtodecimal = (num) => {
    const n = Number(num);
    return (Number.isFinite(n) ? n : 0).toFixed(2);
  };
  // Old version: new Blob([atob(...)]) re-encodes bytes > 127 as UTF-8 and
  // corrupts the PDF, and the MIME type was "data:...;base64"
  // POS print returns a blob: URL (or a data: URL); fetch() reads both, exactly
  // like the POS Print / PDF buttons. The manual decoder below stays as the
  // fallback for a data URL fetch() cannot read.
  const UrlToFile = async (dataUrl, fileName) => {
    const strUrl = String(dataUrl || "");
    if (!strUrl) return null;
    try {
      const response = await fetch(strUrl);
      if (response.ok) {
        const blob = await response.blob();
        if (blob && blob.size)
          return new File([blob], fileName, { type: blob.type || "application/pdf" });
      }
    } catch (e) {
      // fall through to the data-URL decoder
    }
    return UrlToFile_Decode(strUrl, fileName);
  };
  const UrlToFile_Decode = (dataUrl, fileName) => {
    // jsPDF gives "data:application/pdf;filename=X;base64,<data>".
    // The file name part may contain a comma, so cut at ";base64," only
    const iComma = dataUrl.indexOf(";base64,");
    if (iComma < 0) return null; // not a base64 data URL (e.g. revoked blob URL)
    const strMime =
      dataUrl.substring(0, iComma).replace(/^data:/, "").split(";")[0] ||
      "application/pdf";
    const strBinary = atob(dataUrl.substring(iComma + 8));
    const arrBytes = new Uint8Array(strBinary.length);
    for (let i = 0; i < strBinary.length; i++) {
      arrBytes[i] = strBinary.charCodeAt(i);
    }
    return new File([arrBytes], fileName, { type: strMime });
  };
  // RFC 5322 "common subset": local@domain.tld, no spaces / consecutive dots,
  // TLD of 2+ letters, max 254 characters
  const IsValidEmail = (strValue) => {
    const v = String(strValue || "").trim();
    return (
      v.length > 0 &&
      v.length <= 254 &&
      !/\.\./.test(v) &&
      /^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*\.[A-Za-z]{2,}$/.test(v)
    );
  };
  // "a@x.com, b@y.com" or "a@x.com; b@y.com" -> ["a@x.com","b@y.com"]
  const ToEmailList = () =>
    Array.from(
      new Set(
        String(strToEmail || "")
          .split(/[;,\s]+/)
          .map((strItem) => CleanEmail(strItem).toLowerCase())
          .filter((strItem) => strItem !== "")
      )
    );

  return (
    <div className="popup-container">
      <div className="popup-content">
        <div className="popup-header">
          <h5>Sent E-mail</h5>
          <div className="icon-popup-btn-grp">
            <span className="icon-btn" onClick={Popup_Close}>
              <i className="fa-regular fa-rectangle-xmark"></i>
            </span>
          </div>
        </div>
        <div className="popup-body">
          <div className="row">
            <div>
              <label>From</label>
              <input
                type="text"
                className="form-control"
                placeholder="Company E-Mail (set in company settings)"
                value={strEmail}
                readOnly
              />
            </div>
            <div>
              <label>To</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Email Address (use , for more than one)"
                value={strToEmail}
                onChange={(e) => setstrToEmail(e.target.value)}
              />
            </div>
            <div>
              <label>Subject</label>
              <input
                type="text"
                className="form-control"
                placeholder="Subject"
                value={strSubject}
                onChange={(e) => setstrSubject(e.target.value)}
              />
            </div>
            <div>
              <label>Message</label>
              <textarea
                className="form-control"
                style={{ height: "60px" }}
                placeholder="Optional note, added to the e-mail"
                value={strMessage}
                onChange={(e) => setstrMessage(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="popup-footer">
          <div className="popup-btn-group">
            <button
              type="button"
              className="btn-fabgreen"
              disabled={bSending}
              onClick={(e) => {
                if (!objEntPdfContent || !objEntPdfContent.PdfURL) {
                  Show_Message(dispatch, "Invoice PDF is not ready", "info");
                } else if (
                  ToEmailList().length === 0 ||
                  ToEmailList().length > 5 ||
                  !ToEmailList().every(IsValidEmail)
                ) {
                  const strBad = ToEmailList().find((x) => !IsValidEmail(x));
                  Show_Message(
                    dispatch,
                    strBad
                      ? `"${strBad}" is not a valid e-mail address`
                      : "Please Enter a valid To E-Mail (maximum 5)",
                    "info"
                  );
                } else if (strSubject.trim() === "") {
                  Show_Message(dispatch, "Please Enter Subject", "info");
                } else {
                  SentEmail(objEntPdfContent);
                }
              }}
            >
              {bSending ? "Sending..." : "Sent Email"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmailPopup;